module.exports = __webpack_public_path__ + "img/rightCircle.19eba6e.png";